<template></template>

<script>
export default {
  created () {
    this.$vs.loading();

    const token = this.$route.query.token;
    const id = this.$route.query.id;
    const email = this.$route.query.email;
    const userType = this.$route.query.userType;
    const terminology = this.$route.query.terminology;
    const companyName = this.$route.query.companyName;
    const organizationType = this.$route.query.organizationType;
    const firstName = this.$route.query.firstName;
    const redirectTo = this.$route.query.redirectTo;
    window.$cookies.set('firstName',  firstName, Infinity);
    localStorage.setItem("accessToken", token);
    localStorage.setItem("feathers-jwt", token);
    localStorage.setItem(
      "userInfo",
      JSON.stringify({
        usersId: id,
        email,
        userType,
        terminology,
        companyName

      })
    );
    window.$cookies.set('companyName', companyName, Infinity);
    window.$cookies.set('organizationType', organizationType, Infinity);
    console.log('redirectTo',redirectTo);
    if (redirectTo) {
      window.location.href = redirectTo;
    }else{
      window.location.href = "/user/profile/view";
    }
   // window.location.href = "/user/profile/edit";

    this.$vs.loading.close();
  }
};
</script>
